import app from '../app';
import Modal from '../../common/components/Modal';
import Button from '../../common/components/Button';
import Stream from '../../common/utils/Stream';
import avatar from '../../common/helpers/avatar';
import Select from '../../common/components/Select';

export default class PuzzleTriggerModal extends Modal {
  oninit(vnode) {
    super.oninit(vnode);
    this.attrs = vnode.attrs;
    this.rotation = {
      outer: 0,
      middle: 0,
      inner: 0,
      right: 0,
    };
    this.answer = '';
    this.dragging = false;
    this.startX = 0;
    this.startY = 0;
    this.imgtiggle = false;
    this.accumulatedDeltaX = 0; // 累计拖拽距离
  }

  className() {
    return `dl-modal-small puzzle-trigger-modal trigger${this.attrs.index}`;
  }

  title() {
    return;
  }
  getGearPositions() {
    const letters = ['e', 't', 'p', 'k', 'l', 'b', 'f', 'h', 'o', 'm', 'c', 'd'];
    const middle = ['↑', 'z', 'g', 'v', 'i', 'w', 'n', 'u', 'a', 'x', 'e', 'y'];
    const inner = ['↑', '', '', '', '', '', '', '', '', '', '', ''];
    return { letters, middle, inner };
  }

  checkAnswer() {
    const { letters, middle } = this.getGearPositions();
    // 计算中层箭头指向的外围字母
    const outerIndex = ((Math.floor(((this.rotation.middle - this.rotation.outer) % 360) / 30) % 12) + 12) % 12;
    const outerLetter = letters[outerIndex];

    // 计算中心箭头指向中层字母
    const middleIndex = ((Math.floor(((this.rotation.inner - this.rotation.middle) % 360) / 30) % 12) + 12) % 12;
    const middleChar = middle[middleIndex];

    // 特殊处理箭头符号
    const middleLetter = middleChar === '↑' ? letters[outerIndex] : middleChar;

    // 映射规则
    const mappings = {
      pa: 'W',
      ti: 'I',
      en: 'S',
      ce: 'E',
      kn: 'P',
      ow: 'O',
      le: 'W',
      dg: 'E',
      ee: 'R',
      mv: 'D',
      hz: 'J',
      fx: 'K',
      by: 'C',
      fv: 'A',
      hu: 'U'
    };
    console.log(`outerLetter: ${outerLetter}, middleLetter: ${middleLetter}`);

    this.answer = mappings[outerLetter + middleLetter] || '';
  }

  onMouseDown(e) {
    e.preventDefault(); // 阻止默认滚动行为
    this.dragging = true;
    this.startX = e.clientX || e.touches[0].clientX;
    this.accumulatedDeltaX = 0; // 初始化累积距离

    const moveHandler = this.onMouseMove.bind(this);
    const upHandler = () => {
      document.removeEventListener('mousemove', moveHandler);
      document.removeEventListener('touchmove', moveHandler);
      this.dragging = false;
    };

    document.addEventListener('mousemove', moveHandler);
    document.addEventListener('touchmove', moveHandler, { passive: false });
    document.addEventListener('mouseup', upHandler, { once: true });
    document.addEventListener('touchend', upHandler, { once: true });
  }

  onMouseMove(e) {
    if (!this.dragging) return;

    const currentX = e.clientX || e.touches[0].clientX;
    this.accumulatedDeltaX += currentX - this.startX;
    this.startX = currentX;
    let deltaX = 100;
    if (window.innerWidth < 768) {
      deltaX = 50; // 移动端灵敏度
    }

    // 每移动固定距离触发一格转动
    if (Math.abs(this.accumulatedDeltaX) >= deltaX) {
      const direction = this.accumulatedDeltaX > 0 ? 'clockwise' : 'counter-clockwise';
      this.rotateGears(direction);
      this.accumulatedDeltaX = 0; // 重置累积
    }
  }

  onMouseUp() {
    this.dragging = false;
    document.removeEventListener('mousemove', this.onMouseMove);
    document.removeEventListener('mouseup', this.onMouseUp);
    document.removeEventListener('touchmove', this.onMouseMove);
    document.removeEventListener('touchend', this.onMouseUp);
  }

  rotateGears(direction) {
    const STEP = 30;
    // 右侧齿轮转动
    this.rotation.right += direction === 'clockwise' ? STEP : -STEP;

    // 左侧复合齿轮联动
    if (direction === 'clockwise') {
      this.rotation.outer -= STEP; // 外围逆时针
      this.rotation.middle += STEP; // 中层顺时针
    } else {
      this.rotation.middle -= STEP; // 中层逆时针
      this.rotation.inner += STEP; // 内层顺时针
    }

    // 限制旋转角度范围
    // ['outer', 'middle', 'inner', 'right'].forEach(part => {
    //   this.rotation[part] = this.rotation[part] % 360;
    // });

    this.checkAnswer();
    m.redraw.sync();
  }
  content() {
    const { letters, middle, inner } = this.getGearPositions();
    return (
      <div className="puzzle-trigger-box">
        <div className="PuzzleModal-content">
          <div className="gear-container">
            {/* 左侧复合齿轮 */}
            <div className="left-gears">
              <div className="gear outer" style={`transform: translate(-50%, -50%) rotate(${this.rotation.outer}deg)`}>
                {letters.map((l, i) => (
                  <span style={`transform: rotate(${i * 30}deg) translateX(-50%)`}>{l}</span>
                ))}
              </div>
              <div className="gear middle" style={`transform: translate(-50%, -50%) rotate(${this.rotation.middle}deg)`}>
                {middle.map((item, i) => (
                  <span style={`transform: rotate(${i * 30}deg) translateX(-50%)`}>{item}</span>
                ))}
              </div>
              <div className="gear inner" style={`transform: translate(-50%, -50%) rotate(${this.rotation.inner}deg)`}>
                {/* {inner.map((item, i) => (
                  <span style={`transform: rotate(${i * 30}deg) translateX(-50%)`}>{item}</span>
                ))} */}
                <img src={`${app.data.pkgLogo.cdnUrl}/${app.data.pkgLogo.ossFile}/upload/guessgamezhishipc/btm-zp1.webp`}></img>
              </div>
            </div>
            <div className='connect-img'>
              <img src={`${app.data.pkgLogo.cdnUrl}/${app.data.pkgLogo.ossFile}/upload/guessgamezhishipc/btm-zpwq3.webp`}></img>
            </div>
            {/* 右侧控制齿轮 */}
            <div className="right-gear-box">
              <div
                className="right-gear"
                onmousedown={this.onMouseDown.bind(this)}
                ontouchstart={this.onMouseDown.bind(this)}
                style={`transform: rotate(${this.rotation.right}deg)`}
              ></div>
              <div className="answer">{this.answer}</div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
